import { map, get } from 'lodash-es';
import { Category } from '../types/Event/Category';
import { Type } from '../types/Event/Type';

const eventCategories: Record<Category, { name: string }> = {
  [Category.Training]: {
    name: 'Training',
  },
  [Category.Race]: {
    name: 'Race',
  },
  [Category.Camping]: {
    name: 'Camping',
  },
  [Category.MultiDay]: {
    name: 'Multi-Day',
  },
  [Category.Hike]: {
    name: 'Hike-A-Bike',
  },
  [Category.Casual]: {
    name: 'Casual',
  },
  [Category.Road]: {
    name: 'Road',
  },
  [Category.Mountain]: {
    name: 'Mountain',
  },
  [Category.Cyclocross]: {
    name: 'Cyclocross',
  },
  [Category.Gravel]: {
    name: 'Gravel',
  },
  [Category.Presentation]: {
    name: 'Presentation',
  },
  [Category.Market]: {
    name: 'Market',
  },
  [Category.Meetup]: {
    name: 'Meetup',
  },
  [Category.Demos]: {
    name: 'Demos',
  },
  [Category.Paid]: {
    name: 'Paid',
  },
  [Category.MixedTerrain]: {
    name: 'Mixed-terrain',
  },
  [Category.Novice]: {
    name: 'Novice',
  },
};

const eventCategoryIdsByType: Record<Type, Category[]> = {
  [Type.Ride]: [
    Category.Casual,
    Category.Training,
    Category.Race,
    Category.Road,
    Category.Gravel,
    Category.Mountain,
    Category.Cyclocross,
    Category.MixedTerrain,
    Category.Hike,
    Category.MultiDay,
    Category.Camping,
    Category.Paid,
  ],
  [Type.Event]: [
    Category.Presentation,
    Category.Meetup,
    Category.Market,
    Category.Paid,
  ],
  [Type.OnlineEvent]: [
    Category.Presentation,
    Category.Meetup,
    Category.Market,
    Category.Paid,
  ],
};

export const getEventCategoryIds = (): Category[] => Object.values(Category);

export const getEventCategoryIdsForType = (eventType: Type): Category[] => eventCategoryIdsByType[eventType];

export const getEventCategoryName = (category: Category): string => get(eventCategories[category], 'name');

export const getEventCategoryOptionsForType = (eventType: Type) => {
  return map(getEventCategoryIdsForType(eventType), (category) => {
    return {
      label: getEventCategoryName(category),
      value: category
    };
  });
}; 